"use strict";

var _toConsumableArray = require("/Users/nicholasbucher/Documents/code/jaeger/jaeger-ui/packages/jaeger-ui/node_modules/@babel/runtime/helpers/toConsumableArray");
var _defineProperty = require("/Users/nicholasbucher/Documents/code/jaeger/jaeger-ui/packages/jaeger-ui/node_modules/@babel/runtime/helpers/defineProperty");
var _objectWithoutProperties = require("/Users/nicholasbucher/Documents/code/jaeger/jaeger-ui/packages/jaeger-ui/node_modules/@babel/runtime/helpers/objectWithoutProperties");
var _excluded = ["className", "style"],
  _excluded2 = ["className", "style"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.assignMergeCss = assignMergeCss;
exports.getProps = getProps;
exports.getValueScaler = void 0;
exports.isSamePropSetter = isSamePropSetter;
// Copyright (c) 2019 Uber Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

function reduce(a, b) {
  // eslint-disable-next-line prefer-const
  var className = a.className,
    style = a.style,
    rest = _objectWithoutProperties(a, _excluded);
  var bClassName = b.className,
    bStyle = b.style,
    bRest = _objectWithoutProperties(b, _excluded2);
  // merge className props
  if (bClassName) {
    className = className ? "".concat(className, " ").concat(bClassName) : bClassName;
  }
  // merge style props
  if (bStyle && typeof bStyle === 'object') {
    style = style ? _objectSpread(_objectSpread({}, style), bStyle) : bStyle;
  }
  return _objectSpread(_objectSpread({
    className: className,
    style: style
  }, rest), bRest);
}
function assignMergeCss() {
  for (var _len = arguments.length, objs = new Array(_len), _key = 0; _key < _len; _key++) {
    objs[_key] = arguments[_key];
  }
  return objs.reduce(reduce);
}
function getProps(propSpec) {
  for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }
  if (!propSpec) {
    return {};
  }
  var specs = Array.isArray(propSpec) ? propSpec : [propSpec];
  var propsList = specs.map(function (spec) {
    return typeof spec === 'function' ? spec.apply(void 0, args) || {} : spec;
  });
  return assignMergeCss.apply(void 0, _toConsumableArray(propsList));
}
var getValueScaler = function () {
  // define via an IIFE to sequester non-public stuff

  var DEFAULT_PARAMS = {
    expAdjuster: 0.5,
    factorMax: 1,
    factorMin: 0,
    valueMax: 1,
    valueMin: 0.3
  };

  // eslint-disable-next-line no-shadow
  function getValueScaler() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _DEFAULT_PARAMS$confi = _objectSpread(_objectSpread({}, DEFAULT_PARAMS), config),
      expAdjuster = _DEFAULT_PARAMS$confi.expAdjuster,
      factorMax = _DEFAULT_PARAMS$confi.factorMax,
      factorMin = _DEFAULT_PARAMS$confi.factorMin,
      valueMax = _DEFAULT_PARAMS$confi.valueMax,
      valueMin = _DEFAULT_PARAMS$confi.valueMin;
    return function scaleValue(factor) {
      if (factor >= factorMax) {
        return valueMax;
      }
      if (factor <= factorMin) {
        return valueMin;
      }
      return valueMin + Math.pow((factor - factorMin) / (factorMax - factorMin), expAdjuster) * (valueMax - valueMin);
    };
  }
  return getValueScaler;
}();
exports.getValueScaler = getValueScaler;
function isSamePropSetter(a, b) {
  if (Array.isArray(a)) {
    if (!Array.isArray(b) || a.length !== b.length) {
      return false;
    }
    return !a.some(function (item, i) {
      return item !== b[i];
    });
  }
  return a === b;
}